import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

// See also import { type SchedulingConfig } from '../../previsit/form.js';
export const SchedulingBlockConfigSchema = z.object({
  practiceIds: z.array(z.string()).min(1, { message: 'At least one practice ID is required' }),
  providerUserIds: z.array(z.string()).optional(),
  appointmentTypes: z
    .array(z.string())
    .min(1, { message: 'At least one appointment type is required' }),
});
export type SchedulingBlockConfig = z.infer<typeof SchedulingBlockConfigSchema>;

export const SchedulingBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Scheduling),
  config: SchedulingBlockConfigSchema,
});
export type SchedulingBlock = z.infer<typeof SchedulingBlockSchema>;
